export const HOME_SHELL_CHUNK = 'home';
export const DEFAULT_HOME_CONTENT_CHUNK = 'dashboards';
const HOME_PATH = '/home';
const toSegments = (path)=>path.split('/').filter((segment)=>segment.length > 0);
const matchedPrefixLength = (url, pathname)=>{
    const urlSegments = toSegments(url);
    const pathnameSegments = toSegments(pathname);
    if (pathnameSegments.length < urlSegments.length) return undefined;
    for(let index = 0; index < urlSegments.length; index += 1){
        const urlSegment = urlSegments[index];
        const isParam = urlSegment.startsWith(':');
        if (!isParam && urlSegment !== pathnameSegments[index]) {
            return undefined;
        }
    }
    return urlSegments.length;
};
export const resolveContentChunkName = (entries, pathname)=>{
    let bestChunkName;
    let bestLength = -1;
    entries.forEach((entry)=>{
        const length = matchedPrefixLength(entry.url, pathname);
        if (length != null && length > bestLength) {
            bestLength = length;
            bestChunkName = entry.chunkName;
        }
    });
    return bestChunkName;
};
export const deriveBootChunkNames = (entries, pathname)=>{
    var _resolveContentChunkName;
    const isHomePath = pathname === HOME_PATH || pathname.startsWith("".concat(HOME_PATH, "/"));
    if (!isHomePath) {
        const chunkName = resolveContentChunkName(entries, pathname);
        return chunkName == null ? [] : [
            chunkName
        ];
    }
    return [
        HOME_SHELL_CHUNK,
        (_resolveContentChunkName = resolveContentChunkName(entries, pathname)) !== null && _resolveContentChunkName !== void 0 ? _resolveContentChunkName : DEFAULT_HOME_CONTENT_CHUNK
    ];
};
// WHY: server-safe single source of truth — pure data + a hand-rolled :param matcher, ZERO imports so the
// Express boot chain (server/server.ts → route-chunk-preload.ts) never reaches a client-only dep absent from
// server-package.json (react-router-dom lives only in the webpack bundle; importing it here crashed the prod
// pod on boot — ANCR-2811). routeConfigs.ts derives its chunk loaders from this same list; the coverage test
// guards that every RouteConfig url stays represented here.
export const ROUTE_CHUNK_ENTRIES = [
    {
        url: '/agreement-studio',
        chunkName: 'agreement-studio'
    },
    {
        url: '/edit-agreement/:relationshipId',
        chunkName: 'agreement-studio'
    },
    {
        url: '/proposal-template-studio',
        chunkName: 'agreement-studio'
    },
    {
        url: '/draft/:draftId',
        chunkName: 'agreement-studio'
    },
    {
        url: '/proposal-template/:templateId',
        chunkName: 'agreement-studio'
    },
    {
        url: '/agreement/:relationshipId',
        chunkName: 'agreement-minisite'
    },
    {
        url: '/home/dashboard',
        chunkName: 'dashboards'
    },
    {
        url: '/home/agreements/signed',
        chunkName: 'dashboards'
    },
    {
        url: '/home/agreements/pending',
        chunkName: 'dashboards'
    },
    {
        url: '/home/agreements/drafts',
        chunkName: 'dashboards'
    },
    {
        url: '/home/agreements/archived',
        chunkName: 'dashboards'
    },
    {
        url: '/home/agreements/templates',
        chunkName: 'proposals-config'
    },
    {
        url: '/home/agreements/defaults',
        chunkName: 'proposals-config'
    },
    {
        url: '/home/invoices',
        chunkName: 'dashboards'
    },
    {
        url: '/home/payments',
        chunkName: 'dashboards'
    },
    {
        url: '/home/contacts',
        chunkName: 'dashboards'
    },
    {
        url: '/home/contacts/import',
        chunkName: 'dashboards'
    },
    {
        url: '/home/clients',
        chunkName: 'dashboards'
    },
    {
        url: '/home/services',
        chunkName: 'services-library'
    },
    {
        url: '/home/services/import',
        chunkName: 'services-library'
    },
    {
        url: '/home/bundles',
        chunkName: 'services-library'
    },
    {
        url: '/home/integrations',
        chunkName: 'integrations'
    },
    {
        url: '/home/settings',
        chunkName: 'settings'
    },
    {
        url: '/home/reports',
        chunkName: 'reports'
    },
    {
        url: '/home/activity',
        chunkName: 'reports'
    },
    {
        url: '/home/activity-logs',
        chunkName: 'reports'
    },
    {
        url: '/home/referrals',
        chunkName: 'dashboards'
    },
    {
        url: '/home/billing',
        chunkName: 'dashboards'
    }
];
export const routeChunkNameFor = (pathname)=>resolveContentChunkName(ROUTE_CHUNK_ENTRIES, pathname);
export const bootRouteChunkNames = (pathname)=>deriveBootChunkNames(ROUTE_CHUNK_ENTRIES, pathname);
